import { ModuleRoute } from 'shared/types'

import home from './home'
import users from './users'
import profiles from './profiles'
import zones from './zones'
import history from './history'
import booking from './booking'
import resourceProfiles from './resourceProfiles'
import resources from './resources'
import building from './building'
import tutorial from './tutorial'
import newsfeed from './newsfeed'
import security from './security'
import bookingConfirmation from './bookingConfirmation'
import deleteAccount from './deleteAccount'
import organizations from './organizations'
import userPreferences from './userPreferences'
import visitorCheckInRequests from './visitorCheckInRequests'
import VisitorCheckInTargets from './visitorCheckInTargets'
import networkMonitoring from './networkMonitoring'
import delegatedAccount from './delegatedAccount'
import lockDevices from './lockDevices'
import locks from './locks'

const routes: ModuleRoute[] = [
  // Add routes below
  ...booking,
  ...home,
  ...newsfeed,
  ...users,
  ...profiles,
  ...resources,
  ...resourceProfiles,
  ...zones,
  ...organizations,
  ...visitorCheckInRequests,
  ...VisitorCheckInTargets,
  ...networkMonitoring,
  ...history,
  ...lockDevices,
  ...locks,
  ...building,
  ...tutorial,
  ...security,
  ...bookingConfirmation,
  ...deleteAccount,
  ...userPreferences,
  ...delegatedAccount,
]

export default routes
